import moment from 'moment';
import Snap from "Snap.svg/dist/snap.svg";
import ObjectCopyService from "external-services/object-copy-service/index";
import {cloneDeep} from 'lodash-es';
import TelemetryService from "app/services/telemetry/telemetry.service";
import TablesLookupService from 'external-services/tables-lookup-service/tablesLookup.service';
import AdminService from 'external-services/diary-admin-service/admin.service';
import DateUtilsService from 'external-services/date-utils-service';

/**
 * Has dependency on floorplan-bundle.js
 */

const NS = 'Plan'; // jshint ignore:line

export const PlanConst = {
  Mode: {
    Layout: 'layout',
    Bookings: 'bookings',
    Restaurant: 'restaurant'
  },
  Memento: {
    Undo: 'undo',
    Redo: 'redo'
  },
  /**
   * `PlanConst.Bookings.duration` gets referenced in loads of places as a fallback
   * for when there is no `service.bookingDuration`, but because there was no value here
   * it could potentially create a JS error. So I added it, but not sure if it ever actually
   * gets used (as far as I can tell `service.bookingDuration` always has a value).
   */
  Bookings: {
    duration: 60
  }
};

export default function PlanService(
  SnapService, SnapConst, PlanConst, Command, Memento, Group, Table, Booking, Section,
  Layout, Structure, Divider, Door, Frame, TextOnly,
  $mdDialog, $filter, $rootScope, $q, $log, $timeout, tableHelpersService,
  floorplanFilterService
) {
  "ngInject";

  const THS = tableHelpersService;

  function Plan(mode, options) {
    this.venue = AdminService.getVenue();
    SnapService.resetBBox();
    var _self = this;
    this.p = null; //SVG paper
    this.m = {
      filters: {},
      schedule: null,
      restaurantStructures: [],
      sections: [],
      layoutLookUp: [],
      layouts: [],
      bookings: []
    }; //model
    this.time = {
      date: moment().startOf('day'), //schedule date
      start: null, //Schedule service start time
      end: null, //Schedule service end time
      show: null, //The plan status currently shown time
      input: null, //The display requested time
    };
    this.s = {}; //sizes
    this.sections = []; //contains instances of Section, used only in mode Restaurant
    this.layouts = []; //contains instances of Layout
    this.structures = []; //contains instances of Structures, only those to be edited and saved by plan (for mode Layout and Restaurant)
    this.tables = []; //contains instaces of Table, instances of Bookings are contained inside Tables
    this.scale = 1;
    this.mode = mode;
    this.selectedElement = null; // editing element (table, structure, section)
    this.bookingsDrag = null;
    this.conf = angular.merge({}, Plan.defaults[mode], options);
    this.memento = this.mode !== PlanConst.Mode.Bookings ? new Memento(null, 1000000 /*1MB*/) : null;

    this.listeners = [];


    if (this.mode === PlanConst.Mode.Bookings) {
      this.listeners.push($rootScope.$on('place-bookings-detail', function (event, originalEvent, table, bookings, showOver) {
        _self.showBookingsDetail(table, bookings, originalEvent, showOver);
      }));
      this.listeners.push($rootScope.$on('remove-bookings-detail', function () {
        if (_self.area.getElement('details-container')) {
          _self.area.removeElement('details-container');
        }
      }));
      this.listeners.push($rootScope.$on('create-booking', function (event, originalEvent, table) {
        _self.createBooking(table, originalEvent);
      }));
      this.listeners.push($rootScope.$on('edit-booking-status', function (event, originalEvent, booking) {
        $rootScope.$broadcast('status-edit', originalEvent, booking.model, _self.m.schedule);
      }));
    }
    if (this.mode === PlanConst.Mode.Restaurant) {
      this.listeners.push($rootScope.$on('place-layouts-switcher', function (event, originalEvent, section, layouts) {
        _self.showSwitcherLayouts(section, layouts, originalEvent);
      }));
      this.listeners.push($rootScope.$on('remove-layouts-switcher', function () {
        _self.area.removeElement('layouts-container');
      }));
      this.listeners.push($rootScope.$on('switch-layout', function (event, originalEvent, layout, section) {
        _self.area.removeElement('layouts-container');
        section.showLayout(layout);
        _self.placeSection(section, section.model.position);
      }));
    }

    var destroy = $rootScope.$on('$stateChangeStart', function () {
      // Remove all listeners
      _.each(_self.listeners, function (listener) {
        listener();
      });
      $rootScope.$broadcast('plan-destroy');
      // Remove this same function
      destroy();
    });

    window.plan = this;
    window.renderedTableLabels = {
      skipped: 0,
      total: 0
    };
    window.renderedTables = {
      removed: 0,
      added: 0
    };
  } // end Plan


  Plan.prototype = {

    destory: function () {
      _.each(this.listeners, function (listener) {
        listener();
      });
      $rootScope.$broadcast('plan-destroy');
    },

    updateSizes: function () {
      //SnapSvg paper
      this.s.ph = this.p.node.clientHeight;
      this.s.pw = this.p.node.clientWidth;
      this.s.snapStep = this.conf.snapStep
      //Toolbar, Menu and ListTables
      if (this.conf.menu) {
        this.s.tw = this.conf.menu.width;
        this.s.mh = this.conf.menu.height;
      } else {
        this.s.tw = 0;
        this.s.mh = 0;
      }
      this.s.lh = this.s.ph - this.s.mh;
      //Area
      this.s.aw = this.s.pw - this.s.tw;
      this.s.ah = this.s.ph;
      //Grid
      if (this.conf.grid) {
        this.s.gs = this.conf.grid.size;
      } else {
        this.s.gs = 1;
      }
      //Ruler
      if (this.conf.ruler) {
        this.s.rw = this.conf.ruler.width;
        this.s.rs = this.conf.ruler.step;
      } else {
        this.s.rw = 0;
        this.s.rs = 0;
      }
      //Floor
      this.s.fw = this.conf.floor.width;
      this.s.fh = this.conf.floor.height;
      //Floor viewport
      this.s.fvw = this.s.aw - this.s.rw;
      this.s.fvh = this.s.ah - this.s.rw;

      //Normalize sizes, needed by DOM inline styles computed with Angular bindings
      this.dom = {
        menu: {},
        ruler: {},
        zoom: {}
      };
      this.dom.menu.show = this.conf.menu != null;
      this.dom.menu.width = this.s.tw;
      this.dom.menu.height = this.s.mh;
      this.dom.ruler.show = this.conf.ruler != null;
      this.dom.ruler.width = this.s.rw;
      this.dom.zoom = this.conf.zoom;
    },

    keyDown: function (e) {
      if (e.keyCode > 36 && e.keyCode < 41) {
        var delta = {
          x: 0,
          y: 0
        };
        switch (e.keyCode) {
          case 37:
            delta.x -= 1;
            break;
          case 38:
            delta.y -= 1;
            break;
          case 39:
            delta.x += 1;
            break;
          case 40:
            delta.y += 1;
            break;
        }
        if (this.selectedElement) {
          var pos;
          switch (this.selectedElement.model.type) {
            case Structure.Type:
              pos = SnapService.sumPositions(this.selectedElement.model.position, delta);
              this.placeStructure(this.selectedElement, pos, true, false);
              break;
            case Section.Type:
              pos = SnapService.sumPositions(this.selectedElement.model.position, delta);
              this.placeSection(this.selectedElement, pos, true, false);
              break;
          }
        }
      }
    },

    /**
     * p - Snap paper to render within
     */
    render: function (p) {
      var _self = this;
      this.p = p;
      window.snap = p;
      this.updateSizes();
      //Watch page resize
      this.resizeTimer = null;
      this.resizeListener = function () {
        if (_self.resizeTimer) {
          window.clearTimeout(_self.resizeTimer);
        }
        _self.resizeTimer = setTimeout(function () {
          _self.applyResize();
        }, 100);
      };
      window.addEventListener('resize', _self.resizeListener);
      this.listeners.push(function () {
        window.removeEventListener('resize', _self.resizeListener);
      });
      if (this.mode !== PlanConst.Mode.Bookings) {
        //Keyboard events
        document.addEventListener("keydown", function (e) {
          _self.keyDown(e);
        });
        this.listeners.push(function () {
          document.removeEventListener('keydown', _self.keyDown);
        });
      }
      //Build plan layers
      //Area (contains floorContainer and rulers)
      this.area = new Group(this.p, 'area', {
        type: SnapConst.Shapes.Rect,
        w: this.s.aw,
        h: this.s.ah
      });
      SnapService.place(this.area, this.s.tw, 0);
      this.area.buildRootElement();
      this.area.getSGroup().addClass(this.mode);
      this.listeners.push(SnapService.addScroll(this.area, function (delta) {
        var newScale = this.scale + this.conf.zoom.step * delta * 4;
        this.setScale(newScale, true);
      }, this));
      //FloorContainer (scalable)
      this.floorContainer = new Group(this.p, 'floorContainer', {
        type: SnapConst.Shapes.Rect,
        w: this.s.aw,
        h: this.s.ah
      });
      this.area.addElement(this.floorContainer, 'floorContainer');
      SnapService.place(this.floorContainer, 0, this.s.rw);
      //Floor (huge size draggable)
      this.floor = new Group(this.p, 'floor', {
        type: SnapConst.Shapes.Rect,
        w: this.s.fw,
        h: this.s.fh
      });
      this.floorContainer.addElement(this.floor, 'floor');
      this.floor.buildRootElement();
      if (this.mode === PlanConst.Mode.Bookings) {
        this.floor.getElement('root').addClass('transparent');
      }
      if (this.conf.grid) {
        var gridPattern = this.p.path("M " + this.s.gs + " 0 L 0 0 0 " + this.s.gs).attr({
          width: this.s.gs,
          height: this.s.gs,
          fill: "none",
          strokeWidth: '0.5px'
        }).pattern(0, 0, this.s.gs, this.s.gs).addClass('darkGray');
        this.floor.getElement('root').attr({
          fill: gridPattern
        });
      } else {
        this.floor.getElement('root').attr({
          fill: 'white'
        });
      }
      this.listeners.push(SnapService.onClick(this.floor, function () {
        this.selectElement(null);
        $rootScope.$broadcast('remove-bookings-detail');
      }, this));
      this.listeners.push(SnapService.onDrag(this.floor, this,
        function () {
          this.moveRuler();
        }
      ));
      this.listeners.push(SnapService.onPinchSpread(this.floor, function (delta) {
        var newScale = this.scale + this.conf.zoom.step * delta;
        this.setScale(newScale, true);
      }, this));
      //Build and append container layers (Restaurant, Layout, Labels, Tables)
      this.layers = {};
      _.each(Plan.Layers, function (name) {
        this.layers[name] = new Group(this.p, name, {
          type: SnapConst.Shapes.Rect,
          w: this.s.fw,
          h: this.s.fh
        });
        this.floor.addElement(this.layers[name], name);
      }, this);

      //Structure action icons
      if (this.mode === PlanConst.Mode.Layout || this.mode === PlanConst.Mode.Restaurant) {
        var size = {
          diameter: 20,
          margin: 2
        };
        var colors = {
          background: SnapConst.Colors.Accent,
          foreground: 'white'
        };
        Plan.getStructureActionIcon(this.p, 'images/rotate-right.svg', size, colors).then(_.bind(function (iconGroup) {
          this.structureRotate = iconGroup;
          this.structureRotate.getSGroup().addClass('structureRotate');
          this.floor.addElement(this.structureRotate, 'structureRotate');
          SnapService.show(this.structureRotate, false);
          this.listeners.push(SnapService.onClick(this.structureRotate, function () {
            if (this.selectedElement && this.selectedElement.model.type === Structure.Type) {
              this.selectedElement.rotate(45);
              this.placeStructureActions();
              this.saveState(new Command(this.selectedElement.model, Command.Actions.Rotate, false));
            }
          }, this));
        }, this));
        Plan.getStructureActionIcon(this.p, 'images/chevron-double-right.svg', size, colors).then(_.bind(function (iconGroup) {
          this.structureSpread = iconGroup;
          this.structureSpread.getSGroup().addClass('structureSpread');
          this.floor.addElement(this.structureSpread, 'structureSpread');
          SnapService.show(this.structureSpread, false);
          this.listeners.push(SnapService.onDrag(this.structureSpread, this,
            function (di) { //onMove
              if (this.selectedElement && this.selectedElement.model.type === Structure.Type) {
                var resized = this.selectedElement.applyResize(di.original.data().shape, di.original.data().anchor, di.delta);
                if (resized) {
                  di.hasResized = true;
                  this.placeStructureActions();
                }
              }
            },
            function (di) { //onStart
              if (this.selectedElement && this.selectedElement.model.type === Structure.Type) {
                var anchor = SnapService.getRectCorners(this.selectedElement.shape, this.selectedElement.model.position, this.selectedElement.model.rotation)[0];
                di.original.data('shape', _.clone(this.selectedElement.shape));
                di.original.data('anchor', anchor);
              }
            },
            function (di) { //onEnd
              if (di.hasResized) {
                this.saveState(new Command(this.selectedElement.model, Command.Actions.Resize, true));
              }
            }, {
              hold: true,
              restore: false
            }
          ));
        }, this));
      }

      //Ruler
      this.buildRuler();

      //Toolbars (Tables, Structures)
      if (this.conf.menu) {
        this.toolbars = {};
        //Tables
        this.toolbars.tables = new Group(this.p, 'tables', {
          type: SnapConst.Shapes.Rect,
          w: this.s.tw,
          h: 15
        });
        this.toolbars.tables.buildRootElement();
        SnapService.place(this.toolbars.tables, 0, this.s.mh);
        SnapService.show(this.toolbars.tables, false);
        this.listeners.push(SnapService.onDrag(this.toolbars.tables));
        this.listeners.push(SnapService.addScroll(this.toolbars.tables, _.bind(function (delta) {
          var pos = SnapService.getPosition(this.toolbars.tables);
          var to = SnapService.sumPositions(pos, {
            x: 0,
            y: delta * this.toolbars.tables.scrollStep
          });
          SnapService.place(this.toolbars.tables, to.x, to.y);
        }, this)));
        //Structure
        this.toolbars.structures = new Group(this.p, 'structures', {
          type: SnapConst.Shapes.Rect,
          w: this.s.tw,
          h: 500
        });
        this.toolbars.structures.buildRootElement();
        SnapService.place(this.toolbars.structures, 0, this.s.mh);
        SnapService.show(this.toolbars.structures, false);
        this.listeners.push(SnapService.onDrag(this.toolbars.structures));
        this.listeners.push(SnapService.addScroll(this.toolbars.structures, _.bind(function (delta) {
          var pos = SnapService.getPosition(this.toolbars.structures);
          var to = SnapService.sumPositions(pos, {
            x: 0,
            y: delta * 30
          });
          SnapService.place(this.toolbars.structures, to.x, to.y);
        }, this)));
        //Fill up toolbars
        this.fillStructuresToolbar();
        this.updateTables();
        //Toolbar (container)
        this.toolbar = new Group(this.p, 'toolbar', {
          type: SnapConst.Shapes.Rect,
          w: this.s.tw,
          h: this.s.ph
        });
        this.toolbar.buildRootElement();
        this.toolbar.addElement(this.toolbars.tables, 'tables');
        this.toolbar.addElement(this.toolbars.structures, 'structures');
      }

      this.updateFloor();
      this.scaleRuler();

      if (this.mode === PlanConst.Mode.Bookings) {
        //Message
        this.message = new Group(this.p, 'message', {
          type: SnapConst.Shapes.Rect,
          w: 500,
          h: 500
        });
        this.message.addElement(this.p.text(0, 0, ''), 'message');
        SnapService.place(this.message, 50, 50);
      }
    },

    applyResize: function () {
      this.updateSizes();
      this.updateToolbarsLimits();
      this.updateFloor();
      this.moveRuler();
    },

    buildRuler: function () {
      if (this.conf.ruler) {
        this.rulerX = new Group(this.p, 'rulerX', {
          type: SnapConst.Shapes.Rect,
          w: this.s.fw,
          h: this.s.rw
        });
        this.rulerX.buildRootElement();
        this.rulerX.getSGroup().addClass('ruler');
        this.rulerX.getElement('root').addClass('darkGray');
        this.rulerY = new Group(this.p, 'rulerY', {
          type: SnapConst.Shapes.Rect,
          w: this.s.fh,
          h: this.s.rw
        });
        this.rulerY.buildRootElement();
        this.rulerY.getSGroup().addClass('ruler');
        this.rulerY.getElement('root').addClass('darkGray');
        this.rulerCorner = new Group(this.p, 'rulerCorner', {
          type: SnapConst.Shapes.Rect,
          w: this.s.rw,
          h: this.s.rw
        });
        this.rulerCorner.buildRootElement();
        this.rulerCorner.getSGroup().addClass('ruler');
        this.rulerCorner.getElement('root').addClass('darkGray');
        this.area.addElement(this.rulerX, 'rulerX');
        this.area.addElement(this.rulerY, 'rulerY');
        this.area.addElement(this.rulerCorner, 'rulerCorner');

        var stepSize = this.s.rs * this.s.gs * this.scale;
        //Ruler X markers
        this.markersX = [];
        var shapeX = {
          type: SnapConst.Shapes.Rect,
          w: this.s.gs,
          h: this.s.rw
        };
        _.times(Math.floor(this.s.fw / (this.s.gs * this.s.rs)), function (n) {
          var marker = new Group(this.p, 'x-' + (n + 1), shapeX);
          marker.addElement(this.p.rect(0, 0, 1, this.s.rw / 2).addClass('step'), 'step');
          marker.addElement(this.p.text(3, this.s.rw / 2 - 2, (n + 1)).addClass('label'), 'label');
          this.markersX.push(marker);
          this.rulerX.addElement(marker.g, marker.name);
          SnapService.place(marker, stepSize * (n + 1), this.s.rw / 2);
        }, this);
        //Ruler Y markers
        this.markersY = [];
        var shapeY = {
          type: SnapConst.Shapes.Rect,
          w: this.s.gs,
          h: this.s.rw
        };
        _.times(Math.floor(this.s.fh / (this.s.gs * this.s.rs)), function (n) {
          var marker = new Group(this.p, 'y-' + (n + 1), shapeY);
          marker.addElement(this.p.rect(0, 0, 1, this.s.rw / 2).addClass('step'), 'step');
          marker.addElement(this.p.text(3, this.s.rw / 2 - 2, (n + 1)).addClass('label'), 'label');
          this.markersY.push(marker);
          this.rulerY.addElement(marker.g, marker.name);
          SnapService.place(marker, stepSize * (n + 1), this.s.rw / 2);
        }, this);

        this.moveRuler();
      }
    },

    scaleRuler: function () {
      if (this.conf.ruler) {
        var stepSize = this.s.rs * this.s.gs * this.scale;
        _.each(this.markersX, function (marker, n) {
          SnapService.place(marker, stepSize * (n + 1), this.s.rw / 2);
        }, this);

        _.each(this.markersY, function (marker, n) {
          SnapService.place(marker, stepSize * (n + 1), this.s.rw / 2);
        }, this);
      }
    },

    moveRuler: function () {
      if (this.conf.ruler) {
        var center = {
          x: this.s.aw,
          y: this.s.rw + SnapService.getPosition(this.floor).y * this.scale
        };
        this.rulerY.g.attr({
          transform: 'r90,0,0T' + center.x + ',' + center.y
        });
        SnapService.place(this.rulerX, SnapService.getPosition(this.floor).x * this.scale, 0);
        SnapService.place(this.rulerCorner, this.s.aw - this.s.rw, 0);
      }
    },

    updateFloor: function () {
      var florBBox = SnapService.calcBBox(this.floor.g);
      var sizeFloor = {
        w: florBBox.w * this.scale,
        h: florBBox.h * this.scale
      };
      var sizeView = {
        w: this.s.fvw,
        h: this.s.fvh
      };
      var pos = SnapService.getPosition(this.floor);
      var limits = {
        left: -((sizeFloor.w - sizeView.w) / this.scale),
        top: -((sizeFloor.h - sizeView.h) / this.scale),
        right: this.s.fw,
        bottom: this.s.fh
      };
      limits.left = limits.left < 0 ? limits.left : 0;
      limits.top = limits.top < 0 ? limits.top : 0;
      SnapService.setTranslateLimit(this.floor, limits);
      SnapService.place(this.floor, pos.x, pos.y);
    },

    refreshTables: function () {

      if (this.mode === PlanConst.Mode.Bookings) {

        _.each(this.tables, function (table) {
          table.refresh(this.time.show);
        }, this);
      }
    },

    updateTables: function () {

      var totalHeight = 15,
        count = 0;
      _.each(this.tables, function (table) {
        if (this.mode === PlanConst.Mode.Layout) {
          //Table is not placed in the plan and not marked for delete, so its available in the toolbar
          var showInToolbar = !table.model.position && !table.model.markedForDelete;
          SnapService.show(table.getMenuTable(), showInToolbar);
          if (showInToolbar) {
            count++;
            SnapService.setTranslateLimit(table.getMenuTable(), {
              top: -this.s.mh + this.s.rw,
              left: 0,
              right: this.s.tw + this.s.fvw
            });
            SnapService.place(table.getMenuTable(), this.s.tw / 2, totalHeight, SnapConst.Aligns.TopCenter);
            totalHeight += SnapService.getShape(table.getMenuTable()).h + 15;
          }
        }

        const tblSGroup = table.getPlanTable().getSGroup();
        var tableIsActive = table.service && table.service.active;
        tblSGroup.toggleClass('inactive', !tableIsActive);

        SnapService.show(table.getPlanTable(), table.model.position != null && !table.model.markedForDelete);
        if (table.model.position && !table.model.markedForDelete) {
          var pos = {
            x: table.model.position.x,
            y: table.model.position.y
          };
          table.model.position = SnapService.place(table.getPlanTable(), table.model.position.x, table.model.position.y);
          table.model.rotation = table.model.rotation ? table.model.rotation : 0;
          var currRotation = SnapService.getRotation(table.getPlanTable());
          if (table.model.rotation - currRotation !== 0) {
            table.rotate((table.model.rotation - currRotation));
          }
          if (table.model.position.x !== pos.x || table.model.position.y !== pos.y) {
            // Table placed before been rotated can have his position wrongly adjusted
            // Try to place to its original position again
            table.model.position = SnapService.place(table.getPlanTable(), pos.x, pos.y);
          }
        }
      }, this);

      //Needed to proper update limits on resize
      if (this.conf.menu) {
        this.toolbars.tables.getElement('root').attr({
          height: totalHeight
        });
        this.toolbars.tables.scrollStep = (totalHeight - 15) / count;
      }

      //Update toolbars limits
      this.updateToolbarsLimits();
    },

    /**
     * Updates the 'service' property of each table.
     * If an event exists, will choose it, otherwise will fall back to whatever is in the schedule.
     */
    updateTableService: function () {

      // creates a list of services with events pushed to the front of the array so they can be chosen first
      const servicesWithEventsFirst = this.getServiceFromSchedule(this.m.schedule);

      // grabs the first service that has the table in question in its 'tablesIdsList', then updates it
      this.tables.forEach(table => {
        const service = servicesWithEventsFirst
          .find(srv => {
            return srv.tablesIdsList && srv.tablesIdsList.indexOf(table.model._id) !== -1;
          });

        if (service) {
          const nextService = this.getNextService(table.model._id);
          table.updateServices(service, nextService);
        }
      });
    },

    /**
     * Finds the next service for a table by checking the layouts for any that contain that table.
     */
    getNextService: function (tableId) {
      const layoutDetail = this.m.layouts.find(layoutDetail => {
        /**
         * At first glance it looks like `layoutDetail.layouts` always just has 1 item in it,
         * but we're looping just in case there are scenarios that would have more.
         */
        const tableIsFound = layoutDetail.layouts.some(o => o.tables.map(tbl => tbl._id).indexOf(tableId) !== -1);
        return tableIsFound;
      });
      return layoutDetail ? layoutDetail.nextService : null;
    },

    /**
     * Gets a list of services from the schedule.
     * If an event exists, will choose it, otherwise will fall back to whatever is in the schedule.
     */
    getServiceFromSchedule: function (schedule) {
      return schedule.services
        .filter(srv => srv.type === 'event')
        .concat(
          schedule.services.filter(srv => srv.type !== 'event')
        );
    },

    updateBlockoutByTable: function () {
      if (!this.tables) {
        return;
      }

      this.tables.forEach(table => {
        const tblSGroup = table.getPlanTable().getSGroup();
        const hasBlockout = THS.getBlockouts(this.mode, table.model, this.m.schedule)
          .some(bo => {
            // console.log('this.time.input', this.time.input.toISOString(), bo)
            return this.time.input &&
              (
                moment(this.time.input).isBetween(bo.start, bo.end) ||
                moment(this.time.input).isSame(bo.start) ||
                moment(this.time.input).isSame(bo.end)
              );
          });

        tblSGroup.toggleClass('blockout', hasBlockout);
      });
    },

    fillStructuresToolbar: function () {
      if (this.conf.structures.enable && (this.mode === PlanConst.Mode.Layout || this.mode === PlanConst.Mode.Restaurant)) {
        //Structure drag move function
        var onMove = function (di) { //onMove
          di.element.toggleClass('active', di.to.x + SnapService.calcBBox(di.element).w > this.s.tw);
        };
        //Structure drag end function
        var onEnd = function (di) {
          if (di.element.hasClass('active')) {
            //Restore toolbar item
            di.element.removeClass('active');
            //Compute floor corresponding position
            var positionOnFloor = SnapService.sumPositions(di.to, {
              x: -this.s.tw,
              y: SnapService.getPosition(this.toolbars.structures).y - this.s.rw
            });
            positionOnFloor.x /= this.scale;
            positionOnFloor.y /= this.scale;
            positionOnFloor = SnapService.diffPositions(positionOnFloor, SnapService.getPosition(this.floor));
            positionOnFloor.x = Math.max(0, positionOnFloor.x);
            positionOnFloor.y = Math.max(0, positionOnFloor.y);
            //Place instance of element
            this.addStructure({
                subType: di.element.data('type'),
                position: positionOnFloor
              },
              this.mode === PlanConst.Mode.Layout ? Plan.Layers.Layouts : Plan.Layers.Restaurant,
              true //editable
            );
          }
        };
        //Initial position
        var pos = {
            x: this.s.tw / 2,
            y: 0
          },
          step = 30;
        //Structures types
        var dictionary = {
          wall: Divider.buildToolbarElement(this.p, Structure.SubTypes.Wall),
          windo: Divider.buildToolbarElement(this.p, Structure.SubTypes.Window),
          doorLeft: Door.buildToolbarElement(this.p, Structure.SubTypes.DoorLeft),
          doorRight: Door.buildToolbarElement(this.p, Structure.SubTypes.DoorRight),
          doorDouble: Door.buildToolbarElement(this.p, Structure.SubTypes.DoorDouble),
          rect: Frame.buildToolbarElement(this.p, Structure.SubTypes.FrameRect),
          circle: Frame.buildToolbarElement(this.p, Structure.SubTypes.FrameCircle),
          label: TextOnly.buildToolbarElement(this.p, Structure.SubTypes.TextOnly)
        };
        //Append, place and drag structures
        _.each(dictionary, function (structure, name) {
          this.toolbars.structures.addElement(structure, name);
          SnapService.place(structure, pos.x, pos.y + step, SnapConst.Aligns.TopCenter);
          pos.y += SnapService.calcBBox(structure.getSGroup()).height + step;
          this.listeners.push(SnapService.onDrag(structure, this, onMove, null, onEnd, {
            restore: true
          }));
        }, this);
        //Update toolbars limits
        this.updateToolbarsLimits();
      } else {
        var message = this.p.text(0, 0, 'This feature will be coming soon');
        this.structure.addElement(message, 'message');
        SnapService.place(message, (SnapService.calcBBox(this.structure.getSGroup()).w - SnapService.calcBBox(message).w) / 2, this.s.mh / 2);
      }
    },

    updateToolbarsLimits: function () {
      if (this.conf.menu) {
        //Tables toolbar
        var box = SnapService.calcBBox(this.toolbars.tables.getSGroup());
        SnapService.setTranslateLimit(this.toolbars.tables, {
          left: 0,
          right: this.s.tw,
          top: box.h < this.s.lh ? this.s.mh : this.s.mh - (box.h - this.s.lh),
          bottom: this.s.ph - (this.s.lh - box.h)
        });
        //Structures toolbar
        this.toolbars.structures.shape = box;
        this.toolbars.structures.getElement('root').attr({
          width: box.w,
          height: box.h
        });
        SnapService.setTranslateLimit(this.toolbars.structures, {
          left: 0,
          right: this.s.tw,
          top: box.h < this.s.lh ? this.s.mh : this.s.mh - (box.h - this.s.lh),
          bottom: this.s.ph - (this.s.lh - box.h)
        });
      }
    },

    addStructure: function (model, target, editable) {
      if (this.conf.structures.enable) {
        editable = editable === true ? true : false;
        var structure = null;
        switch (model.subType) {
          case Structure.SubTypes.Wall:
          case Structure.SubTypes.Window:
            structure = new Divider(this.p, this.mode, model);
            break;
          case Structure.SubTypes.DoorLeft:
          case Structure.SubTypes.DoorRight:
          case Structure.SubTypes.DoorDouble:
            structure = new Door(this.p, this.mode, model);
            break;
          case Structure.SubTypes.FrameRect:
          case Structure.SubTypes.FrameCircle:
            structure = new Frame(this.p, this.mode, model);
            break;
          case Structure.SubTypes.TextOnly:
            structure = new TextOnly(this.p, this.mode, model);
            break;
        }
        if (structure) {
          //Apply the structure to the default layer based on the working mode
          SnapService.enableGestures(structure.getElement(), editable);
          this.layers[target].addElement(structure.getElement(), structure.model._id);
          //Store the structure if editable (for saving purpose) or in Bookings mode (layouts one only, no save but used for incremental rendering)
          if (editable || (this.mode === PlanConst.Mode.Bookings && target === Plan.Layers.Layouts)) {
            this.structures.push(structure);
          }
          if (editable) {
            //Enable selection
            this.listeners.push(SnapService.onClick(structure.getElement(), function () {
              this.selectElement(structure);
            }, this));
            //Boundaries of movement
            SnapService.setTranslateLimit(structure.getElement(), {
              //left: 0, no left limit to allow remove by drag outside to the left
              top: 0,
              bottom: this.s.fh,
              right: this.s.fw
            });
            this.listeners.push(SnapService.onDrag(structure.getElement(), this,
              function (di) { // onMove
                di.element.toggleClass('remove', SnapService.calcBBox(di.element).x < 0);
                this.placeStructure(structure, SnapService.getPosition(structure.getElement()), false, true);
              },
              null,
              function (di) { // onEnd
                if (SnapService.calcBBox(di.element).x < 0) {
                  this.removeStructure(structure, this.layer);
                } else {
                  this.placeStructure(structure, structure.model.position, true, true);
                }
              }));
            //Checkpoint for new structure
            this.saveState(new Command(structure.model, Command.Actions.Add, true));
          }
        }
      }
    },

    removeStructure: function (structure, layerTarget) {
      if (structure.getElement().getSGroup().hasClass('selected')) {
        this.selectElement(null);
      }
      this.structures.splice(_.indexOf(this.structures, structure), 1);
      this.layers[layerTarget].removeElement(structure.model._id);
      //Checkpoint for removed structure
      this.saveState(new Command(structure.model, Command.Actions.Remove, true));
    },

    placeStructureActions: function () {
      if (this.selectedElement && this.selectedElement.model.type === Structure.Type) {
        //Faking bigger shape and topleft translated structure to get larger corners, to place the spread action next to the figure instead of over
        var margin, angleAdjust, spreadCenter, structure = this.selectedElement;

        //Spread center
        if (structure.model.subType === Structure.SubTypes.Wall || structure.model.subType === Structure.SubTypes.Window) {
          //dividers
          margin = 12;
          angleAdjust = 0;
        } else {
          //frames
          margin = 8;
          angleAdjust = 45;
        }
        //Faking bigger shape and topleft translated structure to get larger corners, to place the spread action next to the figure instead of over
        var fakeSize = {
          w: structure.shape.w + margin * 2,
          h: structure.shape.h + margin * 2
        };
        var fakePos = {
          x: structure.model.position.x - margin,
          y: structure.model.position.y - margin
        };
        var corners = SnapService.getRectCorners(fakeSize, fakePos, structure.model.rotation);
        if (structure.model.subType === Structure.SubTypes.Wall || structure.model.subType === Structure.SubTypes.Window) {
          spreadCenter = {
            x: (corners[1].x + corners[2].x) / 2,
            y: (corners[1].y + corners[2].y) / 2
          };
        } else {
          spreadCenter = corners[2];
        }
        var spreadDistance = SnapService.get2PointsDistance( //distance from structure center and spread icon center
          SnapService.sumPositions(structure.model.position, SnapService.getShapeCenter(structure.shape)),
          spreadCenter);
        //Rotate action
        var delta = 30;
        var rotatePos = {
          x: structure.model.position.x + structure.shape.w / 2 - this.structureRotate.shape.w / 2,
          y: structure.model.position.y + structure.shape.h / 2 - this.structureRotate.shape.h / 2
        };

        if (structure.actions.spread) {
          //Check and fix collision between spread and rotate icons
          if (spreadDistance + this.structureSpread.shape.h / 2 > delta - this.structureRotate.shape.h / 2 &&
            spreadDistance - this.structureSpread.shape.h / 2 < delta + this.structureRotate.shape.h / 2) {
            delta += this.structureRotate.shape.h * 2;
          }
        }
        rotatePos.y += (rotatePos.y - delta) < 0 ? delta : -delta;
        SnapService.place(this.structureRotate, rotatePos.x, rotatePos.y);

        //Spread action
        var crot = SnapService.getRotation(this.structureSpread);
        crot = (crot > 0 ? -crot : Math.abs(crot));
        SnapService.rotate(this.structureSpread, crot);
        var spreadPos = {
          x: spreadCenter.x - this.structureSpread.shape.w / 2,
          y: spreadCenter.y - this.structureSpread.shape.h / 2
        };
        SnapService.place(this.structureSpread, spreadPos.x, spreadPos.y);
        SnapService.rotate(this.structureSpread, structure.model.rotation + angleAdjust);
      }
    },

    placeSection: function (section, position, saveState, saveAtomic) {
      section.model.position = SnapService.place(section.getElement(), position.x, position.y);
      var labelPosition = SnapService.sumPositions(section.model.position, section.labelPosition);
      SnapService.place(section.label, labelPosition.x, labelPosition.y);
      if (saveState) {
        this.saveState(new Command(section.model, Command.Actions.Move, saveAtomic));
      }
    },

    placeStructure: function (structure, position, saveState, saveAtomic) {
      var oldPos = cloneDeep(structure.model.position);
      structure.place(position);
      if (!saveAtomic && SnapService.calcBBox(structure.getElement().getSGroup()).x < 0) {
        //For keyboard movement that end over floor left margin restore previous position
        structure.place(oldPos);
      } else {
        structure.model.position = SnapService.getPosition(structure.getElement());
        this.placeStructureActions();
        if (saveState) {
          //Checkpoint for moved structure
          this.saveState(new Command(structure.model, Command.Actions.Move, saveAtomic));
        }
      }
    },

    setScale: function (scale, fire) {
      scale = Math.min(Math.max(scale, this.conf.zoom.from), this.conf.zoom.to);
      if (scale !== this.scale) {
        this.scale = scale;
        $rootScope.$broadcast('remove-bookings-detail');
        SnapService.scale(this.floorContainer, this.scale, this.scale);
        this.updateFloor();
        this.scaleRuler();
        if (fire && typeof this.conf.onChangedZoom === 'function') {
          this.conf.onChangedZoom(this.scale);
        }
      }

    },

    adjustFloorScale: function () {
      // prevents JS error
      if (!this.m.layouts.length) {
        return;
      }
      var topLeft = null,
        box = null,
        step = 40;
      var filtered = this.mode === PlanConst.Mode.Bookings && (!_.isEmpty(this.m.filters.services) || this.m.filters.sections != null);
      if (filtered) {
        box = SnapService.mergeBoxes.apply(this, _.pluck(this.m.layouts, 'box'));
        topLeft = {
          x: Math.min((step - box.x), 0),
          y: Math.min((step - box.y), 0)
        };
      } else {
        var structuresBox = Plan.getStructuresBox(this.mode === PlanConst.Mode.Bookings ? this.m.restaurantStructures : this.structures);
        var tablesBox = Plan.getTablesBox(this.tables);
        var sectionsBox = Plan.getSectionsBox(this.sections);
        box = SnapService.mergeBoxes(structuresBox, tablesBox, sectionsBox);
        topLeft = {
          x: 0,
          y: 0
        };
      }

      //console.log('Adjust floor scale', box, topLeft, filtered);
      SnapService.place(this.floor, topLeft.x, topLeft.y);
      this.moveRuler();

      box = box || {
        x2: 0,
        y2: 0,
        w: 0,
        h: 0
      };
      var size = filtered ? {
        w: box.w + step,
        h: box.h + step
      } : {
        w: box.x2,
        h: box.y2
      };
      size.w += Math.max(20, this.s.rw);
      size.h += Math.max(20, this.s.rw);
      var scale = Math.min(this.conf.zoom.maxStart, Math.min(this.s.fvw / size.w, this.s.fvh / size.h));
      this.setScale(scale);
    },

    selectLayer: function (name, force) {
      if (this.conf.menu && (this.layer !== name || force)) {
        //Deselect any selected element, an element is selectable in one single layer
        this.selectElement(null);
        //Register new layer
        this.layer = name;
        //Configure plan accordingly to selected layer
        SnapService.show(this.toolbars.tables, this.layer === Plan.Layers.Tables);
        SnapService.show(this.toolbars.structures, this.layer !== Plan.Layers.Tables);
        _.each(this.structures, function (structure) {
          SnapService.enableGestures(structure.getElement(), this.layer !== Plan.Layers.Tables);
        }, this);
        _.each(this.tables, function (table) {
          SnapService.enableGestures(table.getPlanTable(), this.layer === Plan.Layers.Tables);
        }, this);
        //Stack layers in natural order and after bring selected to front
        this.layers[Plan.Layers.Restaurant].getSGroup().appendTo(this.floor.getSGroup());
        this.layers[Plan.Layers.Layouts].getSGroup().appendTo(this.floor.getSGroup());
        this.layers[Plan.Layers.Tables].getSGroup().appendTo(this.floor.getSGroup());
        this.layers[this.layer].getSGroup().appendTo(this.floor.getSGroup());
        //Append structure action icons always after layers
        this.structureRotate?.getSGroup().appendTo(this.floor.getSGroup());
        this.structureSpread?.getSGroup().appendTo(this.floor.getSGroup());
        //Configured callback
        if (typeof this.conf.onSelectedLayer === 'function') {
          this.conf.onSelectedLayer(this.layer);
        }
      }
    },

    requestRefresh: function (force, reason, cb) {
      // window.buildStart = performance.now();
      if (this.mode === PlanConst.Mode.Bookings && this.m.schedule && this.m.layoutLookUp) {
        if (this.lastRefreshRequest) {
          $timeout.cancel(this.lastRefreshRequest);
        }

        const delayedFn = (force, reason) => {
          this.lastRefreshRequest = null;
          this.applyRefresh(force, reason, cb);
        };
        // removed _.delay as it is too hard to unit test. Using $timeout instead
        this.lastRefreshRequest = $timeout(delayedFn, 50  , true, force, reason);
      }
    },

    /**
     * Refresh the plan by show the status (layouts & bookings) corresponding to show time
     * Determine show time:
     * See setSchedule for time.input
     * Determine visible layouts (eventually marked as 'inactive')
     * Filter layouts running on show time
     * Look up for sections not represented by running layouts and pick up the nearest layout for it, this layout is marked as 'inactive'
     * Remove layouts not matching the filters (service/section)
     * 2. Filter layouts that are open (startTime, endTime) at show time and connected to the filered service and sections
     * 3. Apply the filtered layouts to the plan
     */
    applyRefresh: function (force, reason, cb) {
      if (this.mode === PlanConst.Mode.Bookings && this.m.schedule && this.m.layoutLookUp) {
        //cloning current show time to later check if apply new is different from old one
        var prevShow = moment(this.time.show);
        var nextShow = moment(this.time.input);
        //Apply refresh when show time has changed or force is required
        var apply = force || !nextShow.isSame(prevShow);
        //console.log('Refresh from', prevShow.format('DD/MM/YYYY hh:mm:ssa'), 'to', nextShow.format('DD/MM/YYYY hh:mm:ssa'), ' apply', apply);
        if (apply) {
          this.time.show = nextShow;
          //On refresh upon a service change, set the time.show to the start of that service
          if (reason === 'service' && !_.isEmpty(this.m.filters.services)) {
            var service = _.find(this.m.schedule.services, function (service) {
              return service._id === this.m.filters.services[0]._id;
            }, this);
            if (service) {
              this.time.show = moment(service.startTime);
              this.time.input = this.time.show.toDate();
            }
          }
          //Clean up eventual booking details
          $rootScope.$broadcast('remove-bookings-detail');

          //Filter serviceLayouts running on time.show and with open section
          var matchingLayouts = _.filter(this.m.schedule.serviceLayouts, function (sl) {
            return sl.layoutId && // removed explicit false check, so that nulls are also excluded from filter (NBI-550)
              !this.time.show.isBefore(moment(sl.startTime)) && // time.show >= start
              this.time.show.isBefore(moment(sl.endTime)); //time.show <= end
          }, this);
          //Mark matching layouts as 'active' (a previous iteraction may have marked them as 'inactive')
          _.each(matchingLayouts, function (sl) {
            sl.inactive = false;
          });

          //Apply service filters (marked as 'inactive' those not matching the service)
          matchingLayouts = _.each(matchingLayouts, function (sl) {
            var matching = _.isEmpty(this.m.filters.services) || _.find(this.m.filters.services, function (service) {
              return service._id === sl.serviceId;
            }, this) != null;
            if (!matching) {
              sl.inactive = true;
            }
          }, this);

          //Look up sections not represented and pick up the nearest layout for it, mark it as 'inactive'
          _.each(this.m.sections, function (section) {
            var represented = _.find(matchingLayouts, function (sl) {
              return section._id === sl.sectionId;
            }) != null;
            if (!represented) {
              var serviceLayout = null;
              //Filter serviceLayouts for current section and sort them by start time
              var sorteds = _.sortBy(_.filter(this.m.schedule.serviceLayouts, function (sl) {
                return sl.sectionId === section._id;
              }), function (sl) {
                return moment(sl.startTime).valueOf();
              });
              //Lookup for the, based on time.show, latest previous layout or next otherwise
              _.each(sorteds, function (sl) {
                if ((moment(sl.endTime).isBefore(this.time.show) || serviceLayout == null) && (sl.layoutId != null && sl.layoutId !== false)) {
                  serviceLayout = sl;
                }
                if (!sl && moment(sl.startTime).isAfter(this.time.show)) {
                  serviceLayout = sl;
                }
              }, this);
              //On found serviceLayout, mark it as 'inactive' and add to matchingLayouts
              if (serviceLayout) {
                serviceLayout.inactive = true;
                matchingLayouts.push(serviceLayout);
              }
            }
          }, this);

          //Apply section filter
          matchingLayouts = _.filter(matchingLayouts, function (sl) {
            return _.isEmpty(this.m.filters.sections) || _.find(this.m.filters.sections, function (sectionId) {
              return sectionId === sl.sectionId;
            }, this) != null;
          }, this);

          if (_.isEmpty(matchingLayouts) === 0) {
            console.log('Refresh found 0 matching layout on working time!');
          }
          /**
           * @toDo move more of the above `matchingLayouts` logic to `floorplanFilterService`.
           */

          //Add to each matchingLayouts the optional following service (needed to show nextComing events on table)
          matchingLayouts.forEach(matchLayout => {
            this.m.schedule.serviceLayouts.forEach(sl => {
              const isNextLayout = floorplanFilterService.checkIsNextLayout(this.m.filters.services, this.m.schedule.services, sl, matchLayout);
              if (isNextLayout) {
                matchLayout.nextLayout = sl;
              }
            });
          });

          // Apply new serviceLayouts to plan
          this.setLayouts(matchingLayouts, cb);//.then(() => cb ? cb() : null);
        }
      }
    },


    /************************************************************************************************************************
     *************************************************************************************************************************
     FILTER METHODS
     *************************************************************************************************************************
     ************************************************************************************************************************/
    filter: function (filters, skip, cb) {
      //Normalize filters
      filters.services = _.filter(filters.services, function (service) {
        return _.isObject(service);
      });
      var force = true;
      var reason = filters.reason;
      delete filters.reason;
      //Save and apply (if needed) new filters
      this.m.filters = filters;
      if (!skip) {
        this.requestRefresh(force, reason, cb);
      } else {
        cb ? cb() : null;
      }
    },

    selectElement: function (element) {
      //Check if a change of selected element is needed, current is different from requested and external editor is in valid state
      if ( //invalid state on editor
        this.editorInvalid ||
        //from unselected to unselected
        (this.selectedElement == null && element == null) ||
        //same element already selected
        (this.selectedElement != null && element != null && this.selectedElement.model.type === element.model.type && this.selectedElement.model._id === element.model._id)
      ) {
        //console.log('selectElement - nothing to change here!');
        return;
      }

      SnapService.show(this.structureRotate, this.selectedStructure != null && this.selectedStructure.actions.rotate);
      SnapService.show(this.structureSpread, this.selectedStructure != null && this.selectedStructure.actions.spread);

      var node = null;
      //Deselect the current element
      if (this.selectedElement != null) {
        //console.log('selectElement - deselect '+this.selectedElement.model.type);
        switch (this.selectedElement.model.type) {
          case THS.Type:
            node = this.selectedElement.getPlanTable().getSGroup();
            break;
          case Structure.Type:
            node = this.selectedElement.getElement().getSGroup();
            SnapService.show(this.structureRotate, false);
            SnapService.show(this.structureSpread, false);
            break;
          case Section.Type:
            node = this.selectedElement.getElement().getSGroup();
            break;
        }
        node.removeClass('selected');
        this.selectedElement = null;
        if (typeof this.conf.onDeselectedElement === 'function') {
          this.conf.onDeselectedElement();
        }
      }

      //Select the requested element
      if (element) {
        this.selectedElement = element;
        //console.log('selectElement - select '+this.selectedElement.model.type);
        switch (this.selectedElement.model.type) {
          case THS.Type:
            node = this.selectedElement.getPlanTable().getSGroup();
            break;
          case Structure.Type:
            node = this.selectedElement.getElement().getSGroup();
            this.placeStructureActions();
            SnapService.show(this.structureRotate, this.selectedElement.actions.rotate);
            SnapService.show(this.structureSpread, this.selectedElement.actions.spread);
            break;
          case Section.Type:
            node = this.selectedElement.getElement().getSGroup();
            break;
        }
        node.addClass('selected');
        if (typeof this.conf.onSelectedElement === 'function') {
          this.conf.onSelectedElement(this.selectedElement);
        }
      }
    },
    /************************************************************************************************************************
     *************************************************************************************************************************
     DATA METHODS
     *************************************************************************************************************************
     ************************************************************************************************************************/
    enable: function (value) {
      this.showAll(value);
      this.memento.enable(value);
    },

    saveState: function (command) {
      //Add a state to the memento is limited to specific modes and when restore action (undo/redo) is not in progress
      if (this.memento && this.memento.canSave()) {
        //Create the current state as a deep copy of plan model data and the source command
        var model = {};
        model.structures = cloneDeep(_.pluck(this.structures, 'model'));
        switch (this.mode) {
          case PlanConst.Mode.Layout:
            model.tables = cloneDeep(_.pluck(this.tables, 'model'));
            break;
          case PlanConst.Mode.Restaurant:
            model.sections = cloneDeep(_.map(this.sections, function (section) {
              return {
                _id: section.model._id,
                position: section.model.position
              };
            }));
            break;
        }
        var state = {
          command: command,
          model: model
        };
        //Check if defined state can override last one on memento
        var prevState = this.memento.getLast();
        var override = prevState != null && state.command.isEquivalentTo(prevState.command);
        //Save the defined state as next one if not equivalent to the last
        //if(!areEquivalent){
        this.memento.save({
          model: model,
          command: command
        }, override);
        // console.log('State saved by', command, 'override', override);
        //} else {
        //console.log('State save skipped due to equivalent command');
        //}
      }
    },

    loadState: function (direction) {
      if (this.memento) {
        var state = null;
        switch (direction) {
          case PlanConst.Memento.Undo:
            if (this.memento.canUndo()) {
              state = this.memento.undo();
            }
            break;
          case PlanConst.Memento.Redo:
            if (this.memento.canRedo()) {
              state = this.memento.redo();
            }
            break;
        }
        if (state) {
          this.memento.enable(false);
          _.delay(_.bind(function () {
            this.applyState(state);
            this.memento.enable(true);
          }, this), 0);
        }
      }
    },

    applyState: function (state) {
      if (state && state.model) {
        this.layers[Plan.Layers.Restaurant].clear();
        this.layers[Plan.Layers.Layouts].clear();
        this.structures = [];
        this.tables = [];
        if (state.model.tables) {
          this.layers[Plan.Layers.Tables].clear();
          this.toolbars.tables.clear();
        }

        switch (this.mode) {
          case PlanConst.Mode.Layout:
            _.each(state.model.structures, function (structure) {
              this.addStructure(structure, Plan.Layers.Layouts, true);
            }, this);
            _.each(state.model.tables, function (table) {
              this.addTable(table, null, true);
            }, this);
            this.updateTables();
            break;
          case PlanConst.Mode.Restaurant:
            this.setRestaurantStructures(state.model.structures);
            _.each(this.sections, function (section) {
              var sectionSavedData = _.find(state.model.sections, function (savedSection) {
                return section.model._id === savedSection._id;
              });
              if (sectionSavedData) {
                this.placeSection(section, sectionSavedData.position);
              }
            }, this);
            break;
        }
        //Force selection of current layer, apply gesture-enabled and style to restored plan elements
        this.selectLayer(this.layer, true);
        this.showAll(true);
      }
    },

    /* Application general settings */
    setGeneralSettings: function (settings) {
      this.settings = settings;
    },

    setSections: function (sections) {
      this.m.sections = sections;
    },

    setRestaurantStructures: function (structures) {
      this.layers[Plan.Layers.Restaurant].clear();
      SnapService.show(this.layers[Plan.Layers.Restaurant], false);
      this.m.restaurantStructures = structures;
      if (this.mode === PlanConst.Mode.Restaurant) {
        this.structures = [];
      }
      _.each(this.m.restaurantStructures, function (structure) {
        this.addStructure(structure, Plan.Layers.Restaurant, this.mode === PlanConst.Mode.Restaurant);
      }, this);
    },

    /*
     * 1. apply new schedule to the plan
     * 2. update the schedule this.time.start and this.time.end
     * 3. define the input time for showing plan
     * Otherwise if this.time.date is different from today use this.time.start (the start of the schedule service)
     * Otherwise if current time is between schedule start-end use current time (show current time for today)
     * Otherwise if current time is before start use this.time.stare, otherwise use this.time.end
     */
    setSchedule: function (schedule, date, filters, cb) {
      this.m.schedule = schedule;
      this.filter(filters, true);
      var now = moment();
      this.time.date = moment(date);
      this.time.start = null;
      this.time.end = null;
      this.time.show = null;
      _.each(schedule.serviceLayouts, function (sl) {
        this.time.start = this.time.start ? moment.min(this.time.start, moment(sl.startTime)) : moment(sl.startTime);
        this.time.end = this.time.end ? moment.max(this.time.end, moment(sl.endTime)) : moment(sl.endTime);
      }, this);
      if (!this.time.date.isSame(moment().startOf('day'))) {
        this.time.input = moment(this.time.start).toDate();
      } else {
        if (!now.isBetween(this.time.start, this.time.end)) {
          if (now.isBefore(this.time.start)) {
            this.time.input = moment(this.time.start).toDate();
          } else {
            this.time.input = moment(this.time.end).toDate();
          }
        } else {
          const timezoneId = AdminService.getVenueTimezoneId();
          this.time.input = DateUtilsService.getVenueTime(timezoneId); //moment(now).startOf('minute').toDate();
        }
      }
      this.requestRefresh(true, 'schedule', cb);
    },

    setLayoutLookUp: function (layoutLookUp, cb) {
      this.m.layoutLookUp = layoutLookUp;
      this.requestRefresh(true, 'layoutLookup', cb);
    },

    //Request is delayed and applied after a specific delay if no other request occured in the meanwhile
    setBookings: function (bookings, cb) {
      if (this.lastBookingRequest) {
        $timeout.cancel(this.lastBookingRequest);
      }
      if (bookings) {
        this.nextBookings = _.clone(bookings);
      }

      var delay = bookings && bookings.length > 0 ? 50 : 250;

      const delayedFn = () => {
        this.lastBookingRequest = null;
        this.applyBookings(cb);
      };
      // removed _.delay as it is too hard to unit test. Using $timeout instead
      this.lastBookingRequest = $timeout(delayedFn, delay);
    },

    applyBookings: function (cb) {

      window.useHTMLTransformation = true;
      SnapService.resetBBox();
      var start = performance.now();

      window.renderedBookings = {
        added: 0,
        refreshed: 0,
        total: 0
      };
      window.renderedTableLabels = {
        skipped: 0,
        total: 0
      };
      var setBookingsTotal = {
        other: 0,
        buildContent: 0
      };
      if (this.mode === PlanConst.Mode.Bookings) {
        //Get configs
        var overdueMinutes = (this.settings && this.settings.highlightOverdue) ? this.settings.highlightOverdueMins : null;
        var conflictsMinutes = (this.settings && this.settings.highlightConflicts) ? this.settings.highlightConflictsMins : null;
        //Store new bookings
        this.m.bookings = this.nextBookings || [];
        //Secure a valid current time
        if (!moment.isMoment(this.time.show)) {
          this.time.show = moment();
        }
        //Clean up opened booking details
        $rootScope.$broadcast('remove-bookings-detail');

        //Apply new bookings to tables
        _.each(this.tables, function setTableBookings(table) {
          table.getPlanTable().getSGroup().removeClass('keep swap');
          var tableBookings = this.m.bookings[table.model._id] != null ? this.m.bookings[table.model._id].bookings : null;
          var timeCost = table.setBookings(tableBookings, this.time.show, overdueMinutes, conflictsMinutes, this.settings.companyNameFirst);
          setBookingsTotal.other += timeCost.other;
          setBookingsTotal.buildContent += timeCost.buildContent;
          //Draggable bookings

          _.each(table.visibleBookings, function applyTableBookingGestures(item) {
            if (item.booking.model.locked !== true && item.booking.justAdded) {
              // console.log('Apply drag to booking');
              delete item.booking.justAdded;
              item.booking.listeners.push(SnapService.onDrag(item.tile, this,
                //onMove
                function (di) {
                  if (di.screenTo.x >= this.p.node.getBoundingClientRect().left &&
                    di.screenTo.y >= this.p.node.getBoundingClientRect().top) { //mouse inside SVG area
                    var over = Snap.getElementByPoint(di.screenTo.x, di.screenTo.y);
                    var found = false;
                    while (over && over.type !== 'svg') {
                      if (over.hasClass('table')) {
                        if (this.bookingsDrag.fromTable.model._id !== over.attr('tableid')) {
                          //Remove keep and swap from all tables, as a fast drag can move directly from one table to another
                          _.each(this.tables, function (table) {
                            table.getPlanTable().getSGroup().removeClass('keep swap');
                          }, this);
                          //Over a valid table (different from previous one)
                          found = true;
                          this.bookingsDrag.toTable = this.getTable(over.attr('tableid'));
                          this.bookingsDrag.swapNeeded = !_.isEmpty(this.bookingsDrag.toTable.visibleBookings) &&
                            !this.bookingsDrag.toTable.model.shared;
                          over.addClass(this.bookingsDrag.swapNeeded ? 'swap' : 'keep');
                        }
                      }
                      over = over.parent();
                    }
                    if (!found) {
                      //Not over a valid table
                      if (this.bookingsDrag && this.bookingsDrag.toTable) {
                        this.bookingsDrag.toTable.getPlanTable().getSGroup().removeClass('keep swap');
                        this.bookingsDrag.toTable = null;
                      }
                    }
                  }
                },
                //onStart
                function (di) {
                  this.bookingsDrag = {
                    fromTable: table,
                    booking: item.booking
                  };
                  table.planTable.getSGroup().removeClass('keep swap');
                  table.planTable.getSGroup().addClass('source');
                  di.element.group().parent().addClass('dragging');
                  this.area.getSGroup().addClass('dragging');
                },
                //onEnd
                function (di) {
                  table.planTable.getSGroup().removeClass('source');
                  di.element.group().parent().removeClass('dragging');
                  this.area.getSGroup().removeClass('dragging');

                  if (this.bookingsDrag.toTable) {
                    var _self = this;
                    this.bookingsDrag.toTable.planTable.getSGroup().removeClass('keep swap');
                    var swapBookingModel = this.bookingsDrag.swapNeeded && _.size(this.bookingsDrag.toTable.visibleBookings) > 0 ? this.bookingsDrag.toTable.visibleBookings[0].booking.model : null;
                    $mdDialog.show({
                      controller: 'DragBookingConfirmCtrl',
                      controllerAs: 'vm',
                      templateUrl: 'app/bookings/timeList/dragBookingConfirm/dragBookingConfirm.html',
                      parent: angular.element(document.body),
                      targetEvent: di.evt,
                      locals: {
                        isFloorPlanV1: true,
                        isFloorPlanV2: false,
                        toTable: this.bookingsDrag.toTable.model,
                        fromTable: this.bookingsDrag.fromTable.model,
                        newTime: null,
                        schedule: this.m.schedule,
                        dragBooking: ObjectCopyService.angularSafeCopy(this.bookingsDrag.booking.model),
                        swapWithBooking: ObjectCopyService.angularSafeCopy(swapBookingModel),
                        toTablesArray: [this.bookingsDrag.toTable.model],
                        fromTableArray: [this.bookingsDrag.fromTable.model],
                        isError: false,
                        isOverlap: false,
                        layouts: [],
                        tableJoinSwapError: false,
                        allTimes: [],
                        hasSwappedTableChanged: false,
                        tableName: ""
                      },
                      clickOutsideToClose: true
                    }).then(function () {
                      _self.bookingsDrag.fromTable.planTable.getSGroup().removeClass('source');
                      if (_self.bookingsDrag.toTable) {
                        _self.bookingsDrag.toTable.planTable.getSGroup().removeClass('keep swap');
                      }
                      _self.bookingsDrag = null;
                    });
                  } else {
                    this.bookingsDrag = null;
                  }
                }, {
                  clone: true,
                  shift: true
                }
              ));
            } //check for locked bookings
          }, this);

        }, this);
        SnapService.printBBox('applyBookings');
        TelemetryService.track('tablePlan-applyBookings', [
          ['duration', SnapService.getDuration(start)],
          ['compute', setBookingsTotal.other],
          ['render', setBookingsTotal.buildContent],
          ['added', window.renderedBookings.added],
          ['refreshed', window.renderedBookings.refreshed]
        ]);
        SnapService.printExecutionTime('applyBookings', start,
          window.renderedBookings.total +
          ': compute ' + (setBookingsTotal.other / 1000).toFixed(2) + ' render ' + (setBookingsTotal.buildContent / 1000).toFixed(2) +
          ' add ' + window.renderedBookings.added + ' refresh ' + window.renderedBookings.refreshed +
          ' labels ' + (window.renderedTableLabels.total - window.renderedTableLabels.skipped) + '/' + window.renderedTableLabels.total, true);
      } // mode === Bookings
      window.useHTMLTransformation = false;
      cb ? cb() : null;
    },

    //Used in Restaurant mode
    setSectionsLayouts: function (sections) {
      var done = $q.defer();
      //Clear previous sections
      this.layers[Plan.Layers.Sections].clear();
      this.layers[Plan.Layers.Labels].clear();
      this.sections = [];
      //Loop for sections/layouts and load tables
      var qTables = [];
      _.each(sections, function (section) {
        _.each(section.layouts, function (layout) {
          qTables.push(TablesLookupService.getAllTablesByIds(layout.tables));
        }, this);
      }, this);
      //Gateway loaded tables
      $q.all(qTables).then(_.bind(function (results) {
        //Assign to each entry its tables
        var idx = 0;
        _.each(sections, function (section) {
          _.each(section.layouts, function (layout) {
            layout.tables = results[idx];
            idx++;
          }, this);
        }, this);
        //Where the magic happens
        sections = this.positionSectionsAndTables(sections);

        //Build and append sections to the plan
        _.each(sections, function (sectionModel) {
          if (sectionModel.box) {
            var section = new Section(this.p, this.mode, sectionModel);
            this.sections.push(section);
            SnapService.setTranslateLimit(section.getElement(), {
              left: 0,
              top: 0,
              bottom: this.s.fh,
              right: this.s.fw
            });
            this.listeners.push(SnapService.onDrag(section.getElement(), this,
              function (di) { //onMove
                var nextPos;
                if (section.getElement().getSGroup().hasClass('selected')) {
                  nextPos = SnapService.diffPositions(di.to, di.floorStartPos);
                  this.placeSection(section, {
                    x: nextPos.x,
                    y: nextPos.y
                  }, false);
                } else {
                  nextPos = SnapService.diffPositions(di.delta, di.floorStartPos);
                  SnapService.place(this.floor, nextPos.x, nextPos.y);
                  this.moveRuler();
                }
              },
              function (di) { //onStart
                di.floorStartPos = SnapService.getPosition(this.floor);
              },
              function () { //onEnd
                this.placeSection(section, section.model.position, true, true);
              }, {
                hold: true
              }
            ));
            this.listeners.push(SnapService.onClick(section.getElement(), function () {
              if (section.getElement().getSGroup().hasClass('selected')) {
                this.selectElement(null);
              } else {
                this.selectElement(section);
              }
            }, this));
            this.layers[Plan.Layers.Sections].addElement(section.getElement(), section.getId());
            //Move section label and message to the sectionLabels layer
            this.layers[Plan.Layers.Labels].addElement(section.label, section.getId());
            //Update label basic position once it's been appended to the DOM
            section.centerLabel();
            section.labelPosition = SnapService.getPosition(section.label);
            this.placeSection(section, section.model.section.position, false);
          }
        }, this);

        this.adjustFloorScale();
        done.resolve();
      }, this));
      return done.promise;
    },

    setLayouts: function (layouts, cb) {
      var perfInfo = {};
      perfInfo.setLayoutStart = performance.now();
      // SnapService.resetBBox();
      window.renderedTables = {
        removed: 0,
        added: 0
      };
      var done = $q.defer();
      var applyNewLayouts = true;

      //Check if layouts changed
      if (this.mode === PlanConst.Mode.Bookings) {
        //Cleanup layouts without layout id
        layouts = _.filter(layouts, function (layout) {
          return layout.layoutId !== null;
        });
        //Check if input layouts (serviceLayout) are different from current ones
        var layoutsAlreadyShown = 0;
        _.each(layouts, function (serviceLayout) {
          if (_.find(this.m.layouts, function (mLayout) {
            return Plan.isSameServiceLayout(serviceLayout, mLayout.serviceLayout);
          }, this) != null) {
            layoutsAlreadyShown++;
          }
        }, this);
        applyNewLayouts = !(layoutsAlreadyShown === _.size(layouts) && _.size(this.m.layouts) === _.size(layouts) && this.m.layouts != null);
      }

      // when editing a floorplan, `this.m.schedule` is null and we don't need to worry about updating services on tables
      if (this.m.schedule) {
        this.updateTableService();
      }

      // Apply new layouts
      if (applyNewLayouts) {
        window.useHTMLTransformation = true;
        if (this.mode !== PlanConst.Mode.Bookings) {
          this.showAll(false);
        }
        //Clean previous layouts
        this.layers[Plan.Layers.Sections].clear();
        this.m.layouts = [];
        this.layouts = [];
        //Gather new layouts data (layout, service, section, tables)
        _.each(layouts, function (value) {
          var lw = {
            section: null,
            layouts: []
          };
          if (this.mode === PlanConst.Mode.Bookings) {
            lw.serviceLayout = value;
            if (this.m.layoutLookUp[value.layoutId]) {
              //Will be altered by the placing process, working on a copy to mantain original untouched
              lw.layouts.push(ObjectCopyService.angularSafeCopy(this.m.layoutLookUp[value.layoutId]));
              lw.service = _.find(this.m.schedule.services, function (service) {
                return service._id === value.serviceId;
              }, this);
              if (value.nextLayout) {
                lw.nextService = _.find(this.m.schedule.services, function (service) {
                  return service._id === value.nextLayout.serviceId;
                }, this);
              }
              //Will be altered by the placing process, working on a copy to mantain original untouched
              lw.section = ObjectCopyService.angularSafeCopy(_.find(this.m.sections, function (section) {
                return lw.layouts[0].sectionId === section._id;
              }));
            }
          } else {
            //Will be altered by the placing process, working on a copy to mantain original untouched
            lw.layouts.push(ObjectCopyService.angularSafeCopy(value));
            lw.section = ObjectCopyService.angularSafeCopy(this.m.sections[0]);
          }
          if (!_.isEmpty(lw.layouts)) {
            this.m.layouts.push(lw);
          }
        }, this);

        //Update closed restaurant message value
        this.showMessage(_.isEmpty(this.m.layouts) ? 'Restaurant is closed at this time' : null);
        perfInfo.loadTablesStart = performance.now();
        //Load tables

        this.loadTablesFromLayouts(this.m.layouts).then(_.bind(function applyLayoutsToPlan(tablesList) {

          //Gateway tables loaded
          perfInfo.loadTablesDuration = SnapService.getDuration(perfInfo.loadTablesStart);
          //Idenfity old/new tables
          var newTables = _.pluck(_.flatten(tablesList, true), '_id');
          var oldTables = _.pluck(_.pluck(this.tables, 'model'), '_id');
          var toDeleteTables = this.mode === PlanConst.Mode.Bookings ? _.difference(oldTables, newTables) : oldTables;
          var toAddTables = this.mode === PlanConst.Mode.Bookings ? _.difference(newTables, oldTables) : newTables;
          //Identify old/new structures
          var newStructures = _.pluck(_.flatten(_.pluck(_.flatten(_.pluck(this.m.layouts, 'layouts'), true), 'structures'), true), '_id');
          var oldStructures = _.pluck(_.pluck(this.structures, 'model'), '_id');
          var toDeleteStructures = this.mode === PlanConst.Mode.Bookings ? _.difference(oldStructures, newStructures) : oldStructures;
          var toAddStructures = this.mode === PlanConst.Mode.Bookings ? _.difference(newStructures, oldStructures) : newStructures;

          //Clean previous tables and structures
          // console.log('Tables', oldTables.length, '>', newTables.length, '-' + toDeleteTables.length + '/+' + toAddTables.length, '||', 'Structures', oldStructures.length, '>', newStructures.length, '-' + toDeleteStructures.length + '/+' + toAddStructures.length);
          _.each(toDeleteTables, function (id) {
            this.deleteTable(this.getTable(id), false, true);
          }, this);
          _.each(toDeleteStructures, function (id) {
            var str = _.find(this.structures, function (s) {
              return s.model._id === id;
            });
            this.removeStructure(str, Plan.Layers.Layouts);
          }, this);
          //Assigned loaded tables to layouts
          _.each(tablesList, function (tables, index) {
            if (this.mode === PlanConst.Mode.Layout) {
              //Needed an untouched copy for save data purpose, see getData function
              this.originalTables = ObjectCopyService.angularSafeCopy(tables);
            }
            this.m.layouts[index].layouts[0].tables = tables;
          }, this);
          //Compute layouts and tables position (needed only for bookings mode)
          if (this.mode === PlanConst.Mode.Bookings) {
            this.m.layouts = this.positionSectionsAndTables(this.m.layouts);
          }

          //Add each section elements (layout.structures, layout.tables) to the plan
          //Except for Layout mode where elements are added directly to the plan, their position need to follow the associated section
          perfInfo.renderTablesStart = performance.now();
          _.each(this.m.layouts, function (lw) {
            _.each(lw.layouts[0].structures, function addStructuresToPlan(structure) {
              if (this.mode !== PlanConst.Mode.Layout) {
                structure.position = SnapService.sumPositions(structure.position, lw.section.position);
              }
              if (_.find(toAddStructures, function (id) {
                return id === structure._id;
              })) {
                this.addStructure(structure, Plan.Layers.Layouts, this.mode === PlanConst.Mode.Layout);
              } else {
                var str = _.find(this.structures, function (s) {
                  return s.model._id === structure._id;
                });
                this.placeStructure(str, structure.position, false, false);
              }
            }, this);
            //Add each layout tables to the plan (only for Layout and positioneds in Bookings)
            _.each(lw.layouts[0].tables, function addTablesToPlan(table) {
              if (this.mode === PlanConst.Mode.Layout || (this.mode === PlanConst.Mode.Bookings && table.position)) {
                if (this.mode !== PlanConst.Mode.Layout) {
                  table.position = SnapService.sumPositions(table.position, lw.section.position);
                }
                if (_.find(toAddTables, function (id) {
                  return id === table._id;
                })) {
                  this.addTable(table, null, true, lw.service, lw.nextService, lw.layouts[0]);
                }
              }
            }, this);
          }, this); //lw
          perfInfo.renderTablesDuration = SnapService.getDuration(perfInfo.renderTablesStart);

          //Update tables
          this.updateTables();

          //Apply layouts borders and positions
          if (this.mode === PlanConst.Mode.Bookings) {
            _.each(this.m.layouts, function applyLayoutBordersToPlan(lw) {
              var layout = new Layout(this.p, this.mode, {
                section: lw.section,
                serviceLayout: lw.serviceLayout,
                layout: lw.layouts[0],
                position: lw.section.position,
                size: lw.box
              });

              this.layers[Plan.Layers.Sections].addElement(layout.getElement(), layout.getId());

              if (layout.isActive()) {
                SnapService.place(layout.getElement(), layout.model.position.x, layout.model.position.y);
                this.layouts.push(layout);
              }
            }, this);
            this.refreshLayoutWrappers();
          }
          //Adjust and refresh plan after table load finished
          this.adjustFloorScale();
          this.refreshTables();
          this.selectLayer(this.layer);

          perfInfo.setLayoutDuration = SnapService.getDuration(perfInfo.setLayoutStart);
          TelemetryService.track('tablePlan-setLayout', [
            ['duration', perfInfo.setLayoutDuration],
            ['tables', tablesList.length],
            ['structures', this.structures.length],
            ['renderDuration', perfInfo.renderTablesDuration]
          ]);

          window.useHTMLTransformation = false;
          this.setBookings(null, cb);
          this.updateBlockoutByTable();
          this.showAll(true);
          done.resolve();
        }, this)) //loaded layouts tables
          .catch(function (err) {
            window.useHTMLTransformation = false;
            $log.error('Failed to load tables', err);
          });
      } //applyNewLayouts - Hard refresh
      else {
        //Soft refresh
        // console.log('Soft refresh - update tables status and bookings');
        this.refreshTables();
        this.setBookings(null, cb);
        this.refreshLayoutWrappers();
        this.updateBlockoutByTable();
        done.resolve();
      }
      return done.promise;
    },

    loadTablesFromLayouts: function (layouts) {

      var done = $q.defer();
      // Flat all tables in a single array to make a single call to DB
      var ids = [];
      _.each(layouts, function (lw) {
        ids = ids.concat(lw.layouts[0].tables);
      }, this);

      // Group results by sections
      var result = [];
      TablesLookupService.getAllTablesByIds(ids).then(function loadedTablesFromDB(tables) {
        _.each(layouts, function (lw) {
          result.push(_.filter(tables, function (t) {
            const existsInResultsAlready = _.flatten(result, true).find(o => o._id === t._id);
            // console.log('existsInResultsAlready', existsInResultsAlready)
            return t.sectionId === lw.section._id && !existsInResultsAlready;
          }));
        });

        const flat = _.flatten(result, true);

        // @todo Determine if this warning is still relevant (I think not). severity: low
        if (ids.length !== tables.length || tables.length !== flat.length) {
          $log.warn('loadTablesFromLayouts - wrong count', ids.length, tables.length, flat.length);
        }

        done.resolve(result);
      });
      return done.promise;
    },

    refreshLayoutWrappers: function () {
      //Remove previous labels
      this.layers[Plan.Layers.Labels].clear();
      //Add each layout label/closed and flag inactive eventually
      _.each(this.layouts, function (layout) {
        var label = layout.getLabel();
        this.layers[Plan.Layers.Labels].addElement(label, layout.getId());
        SnapService.place(label, layout.model.position.x, layout.model.position.y);
      }, this);
      //Add/remove inactive class to this layout tables
      _.each(this.tables, function (table) {
        var layout = _.find(this.layouts, function (layout) {
          return table.layout._id === layout.model.layout._id;
        }, this);

        var tableIsActive = table.service && table.service.active;
        if (layout) {
          let serviceInactive = layout.model.serviceLayout.inactive;
          table.getPlanTable().getSGroup().toggleClass('inactive', serviceInactive || !tableIsActive && serviceInactive);
        } else {
          table.getPlanTable().getSGroup().toggleClass('inactive', !tableIsActive);
        }
      }, this);
    },

    /*
     * This function alter position of element, do not save date after its invocation
     * Entry : {section, layouts[{structures[], tables[]}]}
     * An entry which had his tables repositioned are marked with repositionedTables = true
     */
    positionSectionsAndTables: function (entries) {
      var step = 20;
      var limit = this.conf.floor.widthLimit;
      //Sort entries by positioned, order
      entries = _.sortBy(entries, function (e) {
        return (e.section.position ? 0 : 10000) + e.section.order; //ascending order
      });
      //Filter entries without all layouts empty (0 tables and 0 structures)
      entries = _.filter(entries, function (e) {
        return _.find(e.layouts, function (l) {
          return (_.size(l.structures) > 0 || _.size(l.tables) > 0);
        }) != null;
      });
      //Position tables and get the entry total box
      _.each(entries, function (e) {
        _.each(e.layouts, function (l) {
          l.repositionedTables = Plan.positionTables(l.tables, step, l.structures);
          var sbox = Plan.getStructuresBox(l.structures);
          var tbox = Plan.getTablesBox(l.tables);
          l.box = SnapService.mergeBoxes(sbox, tbox);
        }, this);
      });
      //Section entries can be translated to top left corner with step delta (clean up empty space), update section box also
      _.each(entries, function (e) {
        _.each(e.layouts, function (l) {
          var delta = SnapService.diffPositions({
            x: step,
            y: step
          }, l.box);
          //top/left translate structures
          _.each(l.structures, function (structure) {
            structure.position = SnapService.sumPositions(structure.position, delta);
          }, this);
          //top/left translate tables
          _.each(l.tables, function (table) { //at this point all tables are positioned
            table.position = SnapService.sumPositions(table.position, delta);
          }, this);
          //update layout box
          l.box = SnapService.moveBox(l.box, delta);
        }, this);
        //Compute section box
        e.box = SnapService.mergeBoxes.apply(this, _.pluck(e.layouts, 'box'));
        //Section box with margins
        if (e.box) {
          e.box.w += step * 2;
          e.box.h += step * 2;
        }
        //console.log('With margin',e.section.name, e.box.x, e.box.y, e.box.w, e.box.h);
      }, this);
      //Split section between positioned and unpositioned
      var split = _.groupBy(entries, function (e) {
        return e.section.position ? 'positioneds' : 'unpositioneds';
      });
      //Update positioned sections boxes
      _.each(split.positioneds, function (positioned) {
        positioned.box = SnapService.moveBox(positioned.box, positioned.section.position);
      }, this);
      //Find bottom right of positioned entries as position to start placing unpositioned sections
      var positionedSectionsBox = SnapService.mergeBoxes.apply(this, _.pluck(split.positioneds, 'box'));
      var unpositionedStart = positionedSectionsBox ? {
        x: positionedSectionsBox.x2,
        y: positionedSectionsBox.y2
      } : null;
      //Autoplace the unpositioned sections from computed starting point and update their box
      var positions = Plan.getAutoPositions(_.pluck(split.unpositioneds, 'box'), limit, unpositionedStart, step);
      _.each(split.unpositioneds, function (unpositioned, idx) {
        unpositioned.section.position = positions[idx];
        unpositioned.box = SnapService.moveBox(unpositioned.box, unpositioned.section.position);
      });
      //Done
      return entries;
    },

    addTable: function (model, idx, skipRefresh, service, nextService, layout) {
      skipRefresh = skipRefresh === true ? true : false;
      var sTable = new Table(
        this.p, //Snap reference
        model, // model
        this.mode, // Plan usage mode
        THS.getBlockouts(this.mode, model, this.m.schedule), // lookup for blockouts
        service, //the running service
        this.conf.events.enable ? nextService : null, //the next coming service
        this.time.show, // showing reference time
        layout //contains info about automatic table join (needed by bookings to compute max capacity)
      );

      idx = idx != null ? idx : this.tables.length;
      this.tables.splice(idx, 0, sTable);
      //MenuTable
      if (this.mode === PlanConst.Mode.Layout) {
        this.toolbars.tables.addElement(sTable.getMenuTable(), sTable.model._id);

        this.listeners.push(SnapService.onDrag(sTable.getMenuTable(), this,
          function (di) { //onMove
            di.element.toggleClass('active', (di.to.x + SnapService.calcBBox(di.element).w > this.s.tw));
          },
          null, //onStart
          function (di) { //onEnd
            if (di.to.x + SnapService.calcBBox(di.element).w > this.s.tw) {
              //move table from menu to floor
              di.element.removeClass('active');
              var tablePositionOnFloor = SnapService.sumPositions(di.to, {
                x: -this.s.tw,
                y: SnapService.getPosition(this.toolbars.tables).y - this.s.rw
              });
              //console.log('menuPos',toPos, 'floorPos', tablePositionOnFloor);
              var floorPos = SnapService.getPosition(this.floor);
              tablePositionOnFloor.x /= this.scale;
              tablePositionOnFloor.y /= this.scale;
              tablePositionOnFloor = SnapService.diffPositions(tablePositionOnFloor, floorPos);
              tablePositionOnFloor.x = Math.max(20, tablePositionOnFloor.x);
              sTable.model.position = SnapService.place(sTable.getPlanTable(), tablePositionOnFloor.x, tablePositionOnFloor.y);
              //Checkpoint moved table
              this.saveState(new Command(sTable.model, Command.Actions.Move));
            }
            this.updateTables();
          }
        ));

        this.listeners.push(SnapService.onClick(sTable.getMenuTable(), function () {
          this.selectElement(sTable);
        }, this));
      }
      //PlanTable
      this.layers[Plan.Layers.Tables].addElement(sTable.getPlanTable(), sTable.model._id);
      if (this.conf.table.drag) {
        SnapService.setTranslateLimit(sTable.getPlanTable(), {
          //left: 0, //Allow table to be dragged to the outside on the left to remove it
          top: 0,
          bottom: this.s.fh,
          right: this.s.fw
        });

        SnapService.setStep(sTable.getPlanTable(), {
          x: this.venue.enableNewFloorPlan ? this.s.snapStep : this.s.gs,
          y: this.venue.enableNewFloorPlan ? this.s.snapStep : this.s.gs,
        });
        this.listeners.push(SnapService.onDrag(sTable.getPlanTable(), this,
          function (di) { //onMove
            di.element.toggleClass('remove', SnapService.calcBBox(SnapService.getElement(di.element)).x < 0);
          },
          null,
          function (di) { //onEnd
            //Save final position
            if (SnapService.calcBBox(SnapService.getElement(di.element)).x < 0) {
              //remove table from plan
              sTable.model.position = null;
              di.element.removeClass('remove');
              if (di.element.hasClass('selected')) {
                this.selectElement(null);
              }
              this.updateTables();
              //Checkpoint moved table
              this.saveState(new Command(sTable.model, Command.Actions.Move));
            } else {
              sTable.model.position = di.to;
              //Checkpoint moved table
              this.saveState(new Command(sTable.model, Command.Actions.Move));
            }
          }
        ));
      }

      if (this.mode === PlanConst.Mode.Layout) {
        this.listeners.push(SnapService.onClick(sTable.getPlanTable(), function () {
          this.selectElement(sTable);
        }, this));
      }

      //Checkpoint added table
      this.saveState(new Command(sTable.model, Command.Actions.Add));

      //Refresh menu tables
      if (!skipRefresh) {
        this.updateTables();
      }

      return sTable;
    },

    refreshTable: function (table) {
      if (this.mode === PlanConst.Mode.Layout) {
        var model = ObjectCopyService.angularSafeCopy(table.model);
        var idx = this.getTableIndex(table);
        var selected = table.getPlanTable().getSGroup().hasClass('selected');
        this.deleteTable(table, false, true);
        var newTable = this.addTable(model, idx, false);
        if (selected) {
          this.selectElement(newTable);
        }
      }
    },

    deleteTable: function (table, softDelete, skipRefresh) {
      skipRefresh = skipRefresh === true ? true : false;
      window.renderedTables.removed++;
      if (table.getPlanTable().getSGroup().hasClass('selected')) {
        this.selectElement(null);
      }
      if (softDelete) {
        table.model.markedForDelete = true;
        //Checkpoint rotated table
        this.saveState(new Command(table.model, Command.Actions.Remove));
      } else {
        var idx = this.getTableIndex(table);
        this.tables.splice(idx, 1);
        if (this.conf.menu) {
          this.toolbars.tables.removeElement(table.model._id);
        }
        this.layers[Plan.Layers.Tables].removeElement(table.model._id);
      }
      if (!skipRefresh) {
        this.updateTables();
      }
    },

    rotateTable: function (rotTable) {
      var currTable = this.getTable(rotTable);
      if (!currTable) {
        console.error('rotateTable not found', rotTable);
      } else {
        currTable.rotate(45);
        //Checkpoint rotated table
        this.saveState(new Command(currTable.model, Command.Actions.Rotate));
        return currTable.model.rotation;
      }
    },

    getTable: function (data) {
      var id = null;
      if (!data) { //nothing
        return null;
      } else if (typeof data === 'string') { //id
        id = data;
      } else if (data._id) { //model
        id = data._id;
      } else if (data.model) { //sTable
        id = data.model._id;
      } else {
        console.info('getTable not valid input', data);
        return null;
      }

      var sTable = _.find(this.tables, function (table) {
        return table.model._id === id;
      });
      if (!sTable) {
        console.warn('getTable not found for id', id);
      }
      return sTable;
    },

    getTableIndex: function (table) {
      return _.indexOf(this.tables, this.getTable(table));
    },

    getStructure: function (data) {
      var id = null;
      if (!data) { //nothing
        return null;
      } else if (typeof data === 'string') { //id
        id = data;
      } else if (data._id) { //model
        id = data._id;
      } else if (data.model) { //sTable
        id = data.model._id;
      } else {
        console.error('getStructure not valid input', data);
        return null;
      }

      var structure = _.find(this.structures, function (structure) {
        return structure.model._id === id;
      });
      if (!structure) {
        console.warn('getStructure not found for id', id);
      }
      return structure;
    },

    refreshStructure: function (structure) {
      structure.refresh();
      //Save stack chechpoint
      this.saveState(new Command(structure.model, Command.Actions.Edit));
    },

    stackStructure: function (structureModel, direction) {
      var target = this.mode === PlanConst.Mode.Layout ? Plan.Layers.Layouts : Plan.Layers.Restaurant;
      var structure = this.getStructure(structureModel);
      if (structure) {
        var idx = _.indexOf(this.structures, this.getStructure(structure));
        var nextIdx;
        switch (direction) {
          case 'bottom':
            nextIdx = 0;
            break;
          case 'top':
            nextIdx = _.size(this.structures);
            break;
          case 'up':
            nextIdx = idx + 1;
            break;
          case 'down':
            nextIdx = idx - 1;
            break;
        }
        nextIdx = Math.min(Math.max(0, nextIdx), _.size(this.structures) - 1);
        if (idx !== nextIdx) {
          this.structures.splice(idx, 1);
          this.structures.splice(nextIdx, 0, structure);
          _.each(this.structures, function (s) {
            s.getElement().getSGroup().appendTo(this.layers[target].getSGroup());
          }, this);
          //Save stack chechpoint
          this.saveState(new Command(structure.model, Command.Actions.Stack));
        }
      }
    },

    getSection: function (data) {
      var id = null;
      if (!data) { //nothing
        return null;
      } else if (typeof data === 'string') { //id
        id = data;
      } else if (data._id) { //model
        id = data._id;
      } else if (data.model) { //sTable
        id = data.model._id;
      } else {
        console.error('getSection not valid input', data);
        return null;
      }

      var section = _.find(this.m.sections, function (section) {
        return section.model._id === id;
      });
      if (!section) {
        console.warn('getSection not found for id', id);
      }
      return section;
    },

    createBooking: function (table, evt) {
      //Create a new booking
      if (this.time.date.isBefore(moment().startOf('day').add(1, 'day'))) {
        //console.log('Create Booking/Walkin');
        $rootScope.$emit('new-booking-type-select', evt, this.time.show.toDate(), table.model);
      } else {
        //console.log('Create Booking');
        $rootScope.$emit('new-booking', evt, this.time.date.toDate(), table.model);
      }
    },

    showMessage: function (message) {
      if (this.mode === PlanConst.Mode.Bookings) {
        SnapService.show(this.message, message != null);
        if (message) {
          this.message.removeElement('message');
          this.message.addElement(this.p.text(0, 0, message), 'message');
        }
      }
    },

    showBookingsDetail: function (table, bookings, evt, showOver) {
      if (!_.isEmpty(bookings)) {
        //Define container size and position
        var rowStep = 5;
        var size = {
          w: Booking.Sizes.Details.w,
          h: ((Booking.Sizes.Details.h + rowStep) * _.size(bookings) - rowStep)
        };
        SnapService.normalizeEventPositions(evt);
        var startDelta = showOver ? (SnapService.isTouch(evt) ? {
          x: 30,
          y: 30
        } : {
          x: 5,
          y: 5
        }) : {
          x: -10,
          y: -10
        };
        var mouseFloorPos = this.getMouseFloorPosition({
          x: evt.x,
          y: evt.y
        });
        var startPos = {
          x: 0,
          y: 0
        };
        //Check that container from startPos with its size do not overflow the floor view size, otherwise invert x and/or y in startpos
        if (mouseFloorPos.x * this.scale + size.w + Math.abs(startDelta.x) < this.s.fvw) {
          //inside
          startPos.x = mouseFloorPos.x - startDelta.x;
        } else {
          //outside
          startPos.x = mouseFloorPos.x - size.w / this.scale + startDelta.x;
        }
        if (mouseFloorPos.y * this.scale + size.h + Math.abs(startDelta.y) < this.s.fvh) {
          startPos.y = mouseFloorPos.y - startDelta.y;
        } else {
          startPos.y = mouseFloorPos.y - size.h / this.scale + startDelta.y;
        }
        //Build and place container
        var container = new Group(this.p, 'details-container', size);
        this.area.addElement(container, 'details-container');
        SnapService.place(container, startPos.x * this.scale, startPos.y * this.scale);
        //Build and append details to the container
        var detailPos = {
          x: 0,
          y: 0
        };
        _.each(bookings, function (booking, idx) {
          var detail = booking.getDetailBooking();
          container.addElement(detail, 'detail_' + idx);
          SnapService.place(detail, detailPos.x * this.scale, detailPos.y * this.scale);
          detailPos = SnapService.sumPositions(detailPos, {
            x: 0,
            y: (Booking.Sizes.Details.h + rowStep) / this.scale
          });
        }, this);


        // Handle remove of details on mouseout (self-close)
        var containerOverlay = SnapService.buildElement(this.p, size).addClass('overlay transparent');
        var outHandler = function () {
          containerOverlay.unmouseout(outHandler);
          // console.log('containerOverlay.mouseout')
          $rootScope.$broadcast('remove-bookings-detail');
        };
        containerOverlay.mouseout(outHandler);
        //Add overly on container, to allow hide on mouseout
        container.addElement(containerOverlay, 'overlay');

        //Lookup for current booking detail based on mouse event position
        if (showOver) {
          _.delay(_.bind(function (ctx) {
            this.listeners.push(SnapService.onClick(containerOverlay, function (evt) {

              var dim = evt.target.getBoundingClientRect();
              SnapService.normalizeEventPositions(evt);
              var pos = {
                x: evt.x - dim.left,
                y: evt.y - dim.top
              };
              var idx = Math.floor(pos.y / (Booking.Sizes.Details.h + rowStep));
              if (bookings[idx]) {
                var relPos = {
                  x: pos.x,
                  y: pos.y - (Booking.Sizes.Details.h + rowStep) * idx
                };
                var isOverStatus = Snap.path.isPointInsideBBox(SnapService.calcBBox(bookings[0].detailBooking.getElement('status')), relPos.x, relPos.y);
                $rootScope.$broadcast('remove-bookings-detail');
                if (isOverStatus) {
                  $rootScope.$broadcast('edit-booking-status', evt, bookings[idx]);
                } else {
                  $rootScope.$broadcast('edit-booking', evt, bookings[idx].model);
                }
              }
              evt.preventDefault();
            }, ctx));
          }, this), 50);
        } //showOver
      }
    },

    showSwitcherLayouts: function (section, layouts, evt) {
      if (!_.isEmpty(layouts)) {
        this.area.removeElement('layouts-container');
        //Define container size and position
        var rowStep = 5;
        var size = {
          w: Layout.Sizes.Details.w,
          h: ((Layout.Sizes.Details.h + rowStep) * _.size(layouts) - rowStep)
        };
        SnapService.normalizeEventPositions(evt);
        var startDelta = {
          x: 0,
          y: 0
        };
        var mouseFloorPos = this.getMouseFloorPosition({
          x: evt.x,
          y: evt.y
        });
        var startPos = {
          x: 0,
          y: 0
        };
        //Check that container from startPos with its size do not overflow the floor view size, otherwise invert x and/or y in startpos
        if (mouseFloorPos.x * this.scale + size.w + Math.abs(startDelta.x) < this.s.fvw) {
          //inside
          startPos.x = mouseFloorPos.x - startDelta.x;
        } else {
          //outside
          startPos.x = mouseFloorPos.x - size.w / this.scale + startDelta.x;
        }
        if (mouseFloorPos.y * this.scale + size.h + Math.abs(startDelta.y) < this.s.fvh) {
          startPos.y = mouseFloorPos.y - startDelta.y;
        } else {
          startPos.y = mouseFloorPos.y - size.h / this.scale + startDelta.y;
        }
        //Build and place container
        var container = new Group(this.p, 'layouts-container', size);
        this.area.addElement(container, 'layouts-container');
        SnapService.place(container, startPos.x * this.scale, startPos.y * this.scale);
        //Build and append details to the container
        var detailPos = {
          x: 0,
          y: 0
        };
        _.each(layouts, function (layout, idx) {
          var detail = Layout.getDetailItem(this.p, layout, section.selectedLayout._id === layout._id);
          container.addElement(detail, 'detail_' + idx);
          SnapService.place(detail, detailPos.x * this.scale, detailPos.y * this.scale);
          detailPos = SnapService.sumPositions(detailPos, {
            x: 0,
            y: (Layout.Sizes.Details.h + rowStep) / this.scale
          });
        }, this);

        //Add overly on container, to allow hide on mouseout
        var containerOverlay = SnapService.buildElement(this.p, size).addClass('overlay transparent');
        var outHandler = function () {
          $rootScope.$broadcast('remove-layouts-switcher');
          containerOverlay.unmouseout(outHandler);
        };
        containerOverlay.mouseout(outHandler);
        container.addElement(containerOverlay, 'overlay');

        //Lookup for current layout switcher based on mouse event position
        _.delay(_.bind(function (ctx) {
          this.listeners.push(SnapService.onClick(containerOverlay, function (evt) {
            var dim = evt.target.getBoundingClientRect();
            SnapService.normalizeEventPositions(evt);
            var pos = {
              x: evt.x - dim.left,
              y: evt.y - dim.top
            };
            var idx = Math.floor(pos.y / (Layout.Sizes.Details.h + rowStep));
            if (layouts[idx]) {
              $rootScope.$broadcast('remove-layouts-switcher');
              $rootScope.$broadcast('switch-layout', evt, layouts[idx], section);
            }
          }, ctx));
        }, this), 50);
      }
    },

    getData: function () {
      var data = {
        structures: _.pluck(this.structures, 'model')
      };
      if (this.mode === PlanConst.Mode.Layout) {
        data.originalTables = this.originalTables;
        data.tables = [];
        _.each(this.tables, function (table) {
          if (!(table.model.markedToAdd && table.model.markedForDelete)) {
            //Table is not a new and deleted one, so needed to be saved
            var model = ObjectCopyService.angularSafeCopy(table.model);
            delete model.markedToAdd;
            data.tables.push(model);
          }
        });
      }
      if (this.mode === PlanConst.Mode.Restaurant) {
        data.sections = _.pluck(this.sections, 'model');
      }
      return data;
    },

    getMouseFloorPosition: function (mousePosition) {
      var areaBBox = SnapService.calcBBox(this.area.getSGroup());
      var svgPosition = {
        x: this.p.node.getBoundingClientRect().left + areaBBox.x - SnapService.getPosition(this.floor).x * this.scale,
        y: this.p.node.getBoundingClientRect().top + areaBBox.y - SnapService.getPosition(this.floor).y * this.scale
      };
      var mouseSvgPosition = SnapService.diffPositions(mousePosition, svgPosition);
      var mouseSvgPositionScaled = {
        x: mouseSvgPosition.x / this.scale,
        y: mouseSvgPosition.y / this.scale
      };
      return mouseSvgPositionScaled;
    },

    drawStructureCorners: function () {
      if (!this.structureCorners) {
        this.structureCorners = [];
        _.times(4, function (n) {
          var corner = this.p.rect(0, 0, 10, 10, 10, 10).addClass('corner');
          corner.attr({
            'data-pos': n
          });
          this.floor.getSGroup().append(corner);
          this.structureCorners.push(corner);
        }, this);
      }
      if (this.selectedStructure) {
        var corners = SnapService.getRectCorners(this.selectedStructure.shape, this.selectedStructure.model.position, this.selectedStructure.model.rotation);
        _.times(4, function (n) {
          SnapService.place(this.structureCorners[n], corners[n].x - 5, corners[n].y - 5);
        }, this);
      }
    },

    showAll: function (visible) {
      _.each(this.layers, function (layer) {
        SnapService.show(layer, visible);
      }, this);
    }
  };

  /************************************************************************************************************************
   *************************************************************************************************************************
   STATIC ATTRIBUTES AND FUNCTIONS
   *************************************************************************************************************************
   ************************************************************************************************************************/

  Plan.Layers = { //respect order of appendTo floor
    Sections: 'sections',
    Restaurant: 'restaurant',
    Layouts: 'layouts',
    Labels: 'labels',
    Tables: 'tables'
  };

  Plan.defaults = {
    layout: {
      menu: {
        width: 275,
        height: 150
      },
      floor: {
        width: 5000,
        height: 5000,
      },
      snapStep: 20,
      grid: {
        size: 20
      },
      ruler: {
        width: 20,
        step: 5 //number of grid cells
      },
      zoom: {
        from: 0.5,
        to: 3,
        step: 0.02,
        maxStart: 1.5
      },
      table: {
        rotate: true,
        drag: true
      },
      structures: {
        enable: true
      }
    },
    bookings: {
      menu: null,
      grid: null,
      ruler: null,
      floor: {
        width: 5000,
        height: 5000,
        widthLimit: 2000
      },
      zoom: {
        from: 0.5,
        to: 3,
        step: 0.02,
        maxStart: 1.5
      },
      table: {
        rotate: false,
        drag: false
      },
      structures: {
        enable: true
      },
      events: {
        enable: true
      }
    },
    restaurant: {
      menu: {
        width: 275,
        height: 0
      },
      grid: {
        size: 20
      },
      ruler: null,
      floor: {
        width: 5000,
        height: 5000,
        widthLimit: 2000
      },
      zoom: {
        from: 0.5,
        to: 3,
        step: 0.02,
        maxStart: 1.5
      },
      table: {
        rotate: false,
        drag: false
      },
      structures: {
        enable: true
      }
    }
  };

  //When at least one table is not positioned, all tables need to be positioned with default position
  Plan.positionTables = function (tables, step, structures) {
    const filteredTables = tables.filter((table) => !table.position);
    if (filteredTables.length === 0) {
      return false;
    }
    const TABLE_MARGIN_BOTTOM = 40;
    const TABLE_START_X = 50;
    const TABLE_MARGIN_RIGHT = 100;
    const LAYOUT_MARGIN = 100;
    const MINIMUM_WIDTH = 400;
    let tableMaxY = 0;
    let tableMaxX = 0;
    tables.forEach((table) => {
      const box = THS.rootBBox(table);
      tableMaxY = Math.max((table.position?.y || 0) + box.h, tableMaxY);
      tableMaxX = Math.max((table.position?.x || 0) + box.w, tableMaxX);
    });
    let structuresMaxY = tableMaxY;
    let structuresMaxX = Math.max(tableMaxX, MINIMUM_WIDTH);
    if (structures) {
      structuresMaxY = Math.max(...structures.map((structure) => {
        if (structure.rotation !== 0 && structure.rotation !== 180 && structure.rotation !== 360) {
          return structure.position.y + ((structure.width || 0) / 2);
        }
        return structure.position.y;
      }), tableMaxY);
      structuresMaxX = Math.max(...structures.map((structure) => {
        let rotationInRadians = structure.rotation * Math.PI / 180;
        const halfWidth = (structure.width || 0) / 2;
        return structure.position.x + halfWidth + (halfWidth * Math.cos(rotationInRadians));
      }), tableMaxX, MINIMUM_WIDTH);
    }
    let row = 0;
    let xPosition = TABLE_START_X;
    let yPosition = structuresMaxY + LAYOUT_MARGIN;
    let maxTableHeight = 0;
    let currentTableWidth = 0;
    filteredTables.forEach((table) => {
      if (xPosition > structuresMaxX) {
        row += 1;
        xPosition = TABLE_START_X;
        yPosition += maxTableHeight + TABLE_MARGIN_BOTTOM;
        maxTableHeight = 0;
      }
      const box = THS.rootBBox(table);
      maxTableHeight = Math.max(maxTableHeight, box.h);
      currentTableWidth = box.w;
      tables.forEach((t) => {
        if (t._id === table._id) {
          t.position = {
            x: xPosition,
            y: yPosition
          };
        }
      });
      xPosition += box.w;
      xPosition += TABLE_MARGIN_RIGHT;
    });
    return tables;
  };

  Plan.getTablesBox = function (tables) {
    var boxes = [];
    _.each(tables, function (table) {
      var model = table instanceof Table ? table.model : table;
      if (model.position) {
        boxes.push(THS.rootBBox(model));
      }
    });
    var result = SnapService.mergeBoxes.apply(this, boxes);
    return result;
  };

  Plan.getStructuresBox = function (structures) {
    var boxes = [];
    _.each(structures, function (structure) {
      boxes.push(Structure.rootBBox(structure.model ? structure.model : structure));
    });
    var result = SnapService.mergeBoxes.apply(this, boxes);
    return result;
  };

  Plan.getSectionsBox = function (sections) {
    var boxes = [];
    _.each(sections, function (section) {
      if (section.model.box) {
        boxes.push(Section.rootBBox(section));
      }
    });
    var result = SnapService.mergeBoxes.apply(this, boxes);
    if (result != null) {
      var increase = 50;
      result.w += increase;
      result.h += increase;
      result.x2 += increase;
      result.y2 += increase;
    }
    return result;
  };

  Plan.getAutoPositions = function (boxes, widthLimit, start, step) {
    var positions = [];
    var row = null;
    start = start || {
      x: 0,
      y: 0
    };
    _.each(boxes, function (box) {
      if (widthLimit != null && box.w + start.x > widthLimit && row > 0) {
        //Move to new row
        start.x = 0;
        start.y += row + step;
        row = 0;
      }
      positions.push({
        x: start.x,
        y: start.y
      });
      start.x = start.x + box.w + step;
      row = Math.max(row, box.h);
    });
    return positions;
  };

  //Two serviceLayout are equal if are using same section, layout and service
  Plan.isSameServiceLayout = function (sl1, sl2) {
    if (!sl1 || !sl2) {
      return false;
    }
    if (sl1.serviceId !== sl2.serviceId) {
      return false;
    }
    if (sl1.layoutId !== sl2.layoutId) {
      return false;
    }
    if (sl1.sectionId !== sl2.sectionId) {
      return false;
    }
    return true;
  };

  Plan.getStructureActionIcon = function (snap, fileName, size, colors) {
    var deferred = $q.defer();
    Snap.load(fileName, function (res) {
      var g = new Group(snap, fileName, {
        type: SnapConst.Shapes.Rect,
        w: size.diameter,
        h: size.diameter
      });
      //background
      var background = snap.rect(0, 0, size.diameter, size.diameter, size.diameter, size.diameter).attr({
        fill: colors.background
      });
      background.addClass('action');
      g.addElement(background, 'background');
      //icon
      var icon = res.select('svg');
      icon.attr({
        fill: colors.foreground
      });
      icon.addClass('icon');
      SnapService.getElement(icon).attr({
        x: size.margin,
        y: size.margin,
        width: size.diameter - size.margin * 2,
        height: size.diameter - size.margin * 2
      });
      g.addElement(icon, 'icon');
      deferred.resolve(g);
    }, this);
    return deferred.promise;
  };

  return Plan;
}
